module.exports = __webpack_public_path__ + "img/eremurus.5e1f69c4.jpg";